import React, { useContext } from 'react';
import { GestureResponderEvent, StyleSheet, TouchableWithoutFeedback, View } from 'react-native';
import { Text, ThemeContext } from '..';
import { TextInput } from '..';

/*eslint-disable react-native/no-unused-styles*/
function getStyles(theme: Theme) {
  return StyleSheet.create({
    container: {
      alignItems: 'center',
      borderColor: '#eeeeee',
      backgroundColor: 'white',
      borderBottomWidth: 1,
      flexDirection: 'row',
      padding: 15,
    },
    edition: {
      flexGrow: 1,
      height: 38,
    },
    first: {
      borderTopWidth: 1,
    },
    innerContainer: {
      paddingHorizontal: 10,
      width: 220,
    },
    selected: {
      backgroundColor: '#f1f1f1',
    },
    subtitle: {
      color: 'grey',
      fontSize: theme.font.size.medium,
    },
    title: {
      fontWeight: theme.font.weight.bold,
    },
    iconContainer: {
      marginRight: 10,
    },
  });
}

export const ListItemRadio = (props: ListItemRadioProps) => {
  const theme = useContext(ThemeContext);
  const styles = getStyles(theme);
  const { IconComponent } = theme;

  const {
    first = false,
    id,
    isEditing,
    onSelect,
    selected = false,
    style,
    subtitle,
    subtitleChanged,
    subtitlePlaceholder,
    title,
  } = props;

  const onChangeText = () => {
    if (subtitleChanged) {
      subtitleChanged({ id, subtitle });
    }
  };

  return (
    <TouchableWithoutFeedback onPress={!isEditing ? onSelect : undefined}>
      <View
        style={[
          styles.container,
          isEditing && { justifyContent: 'space-between' },
          first && styles.first,
          selected && !isEditing && styles.selected,
          style,
        ]}
      >
        {!isEditing && selected && <IconComponent color="#d4d4d4" name="roundcheckbox" size={31} />}
        {!isEditing && !selected && <IconComponent color="#d4d4d4" name="roundcheckbox-outline" size={31} />}
        <View style={styles.innerContainer}>
          {isEditing ? (
            <TextInput
              defaultValue={subtitle}
              onChangeText={onChangeText}
              placeholder={subtitlePlaceholder}
              placeholderTextColor="grey"
              style={[styles.subtitle, styles.edition]}
              underlineColorAndroid="grey"
            />
          ) : null}
          {subtitle && !isEditing ? <Text style={[styles.title, styles.subtitle]}>{subtitle}</Text> : null}
          <Text style={styles.title}>{title}</Text>
        </View>
      </View>
    </TouchableWithoutFeedback>
  );
};

interface ListItemRadioProps {
  first?: boolean;
  id: number | string;
  isEditing: boolean;
  onSelect: (event: GestureResponderEvent) => void;
  selected?: boolean;
  style?: Record<string, any>;
  subtitle: string;
  subtitleChanged: Function;
  subtitlePlaceholder: string;
  title: string;
}
